/**
 * Mutu Buah API Configuration
 * Centralized API endpoint constants
 */

export const MUTU_BUAH_API_CONFIG = {
  DETAILS: '/api/inspection/mutu-buah/details',
} as const;

export const DEFAULT_CATEGORY_ID = 11; // Mutu Buah inspection category
